import { createSelector } from 'reselect';

const selectCache = (state: any) => state.reports;

export const selectReportingResources = createSelector(
  selectCache,
  (cache: any) => cache.resources
);

export const selectIsResoucesLoading = createSelector(
  selectCache,
  (cache: any) => cache.loading
);

export const selectReportToken = createSelector(
  selectCache,
  (cache: any) => cache.token
);

export const selectFilterLoader = createSelector(
  selectCache,
  (cache: any) => cache.filterLoader
);

export const selectIsReportLoading = createSelector(
  selectCache,
  (cache: any) => cache.isReportLoading
);

export const selectReportingError = createSelector(
  selectCache,
  (cache: any) => cache.error
);

export const selectInputControls = createSelector(
  selectCache,
  (cache: any) => cache.inputControls
);
